<template>
    <div class="container">
        <page-header :title="title"></page-header>
        <div class="content" v-watermark>
            <div class="tab-box">
                <div class="tab">
                    <div class="tab-item" v-for="item in tabList" :key="item.id" :class="{'active': item.id == currentId}" @click="handleTab(item.id)">
                        {{ item.text }}
                    </div>
                </div>
            </div>
            <write v-show="currentId == 1" :formData="formData" @efficacyTrackSave="efficacyTrackSave" ref="write"></write>
            <div class="read" v-show="currentId == 2">
                <read ref="read"></read>
            </div>
        </div>
        <prev-page @back="back"></prev-page>
    </div>
</template>
<script>
    import write from './components/write.vue'
    import read from './components/read.vue'
    import {efficacyTrackSave} from '../../api/index'
    import { parseTime } from '../../utils/index'
    export default {
        components: {
            write,
            read
        },
        data() {
            return {
                title: '跟进记录',
                tabList: [
                    { id: 1, text: '写记录' },
                    { id: 2, text: '看记录' }
                ],
                currentId: 1,
                formData: {
                    userNo: '',
                    userMemberId: '',
                    userMemberName: '',
                    diseaseType: '',
                    trackContent: '',
                    trackPic: [],
                    trackStatus: '',
                    trackTime: '',
                    trackType: '',
                    nextTrackTime: '',
                    trackRemark: ''
                },
            }
        },
        activated() {
            Object.keys(this.formData).forEach(key => {
                if(key == 'trackPic'){
                    this.formData[key] = []
                }else {
                    this.formData[key] = ''
                }
            })
            if(this.$route.query.currentId){
                this.currentId = this.$route.query.currentId
                let newQuery = JSON.parse(JSON.stringify(this.$route.query))
                delete newQuery.currentId
                this.$router.replace({ query: newQuery })
            }
            this.formData.userNo = this.$route.query.userNo
            this.formData.userMemberId = this.$route.query.userMemberId
            this.formData.userMemberName = this.$route.query.userMemberName
            this.$nextTick(() => {
                if(this.currentId == 1){
                    this.$refs.write.diseaseType = ''
                    this.$refs.write.trackStatus = ''
                    this.$refs.write.trackType = ''
                }
            })
        },
        methods: {
            handleTab(id) {
                if(this.currentId == id) return
                this.currentId = id
                if(this.currentId == 1){
                    this.formData.diseaseType = '';
                    this.formData.trackStatus = '';
                    this.formData.trackType = '';
                    this.$refs.write.diseaseType = ''
                    this.$refs.write.trackStatus = ''
                    this.$refs.write.trackType = ''
                }else {
                    this.$refs.read.selectByCondition()
                }
            },
            // 保存疗效跟进记录
            efficacyTrackSave(formData) {
                let data = JSON.parse(JSON.stringify(formData))
                let trackPic = [].concat(data.trackPic)
                if(trackPic.length > 0){
                    data.trackPic = trackPic.map(item => item.url)
                    data.trackPic = data.trackPic.join(',')
                }else {
                    data.trackPic = ''
                }
                efficacyTrackSave(data).then(res => {
                    if(res.code == 0){
                        this.$toast.success('新增疗效跟进记录成功')
                        Object.keys(this.formData).forEach(key => {
                            this.formData[key] = ''
                        })
                        this.formData.userNo = this.$route.query.userNo
                        this.formData.userMemberId = this.$route.query.userMemberId
                        this.formData.userMemberName = this.$route.query.userMemberName
                        this.formData.trackPic = []
                        this.$refs.write.diseaseType = ''
                        this.$refs.write.trackStatus = ''
                        this.$refs.write.trackType = ''
                    }
                })
            },
            back() {
                if(this.currentId == 1){
                    if(this.isWrite()){
                        this.$dialog.confirm({
                            title: '提示',
                            message: '记录尚未保存,未保存的记录将不作保留,是否继续返回上级页面?'
                        }).then(() => {
                            this.$refs.write.$refs.form.resetValidation()
                            this.$router.back()
                        })
                    }else {
                        this.$refs.write.$refs.form.resetValidation()
                        this.$router.back()
                    }
                }else {
                    this.$refs.write.$refs.form.resetValidation()
                    this.$router.back()
                }
            },
            // 判断是否填写记录
            isWrite() {
                let data = this.formData
                for(var key in data){
                    if(key == 'trackPic'){
                        if(data[key].length > 0) return true 
                    }else if(key != 'userNo' && key != 'userMemberId' && key != 'userMemberName' ){
                        if(data[key] !== '' && data[key] !== null && data[key] !== undefined ) return true 
                    }
                }
                return false
            }
        }
    }
</script>
<style lang="scss" scoped>
    .container {
        padding: 0 10px;
        padding-bottom: 90px;
        .content {
            background: #fff;
            border-radius: 4px;
            padding-bottom: 30px;
            .tab-box {
                padding: 30px 0;
                display: flex;
                justify-content: center;
                .tab {
                    width: 200px;
                    height: 44px;
                    font-size: 16px;
                    border-radius: 8px;
                    border: 1px solid #E1E8EF;
                    overflow: hidden;
                    display: flex;
                    color: #999;
                    .tab-item {
                        width: 50%;
                        line-height: 44px;
                        text-align: center;
                        cursor: pointer;
                    }
                    .active {
                        color: #fff;
                        background: #0082EF;
                    }
                }
            }
            .read {
                padding: 0 10px;
            }
        }
    }
</style>
<style scoped>
    .content {
        height: calc(100vh - 170px);
        overflow-y: auto;
    }
</style>